import { html } from "lit";

export const starlightCurve = () => html`
  <svg class="twf-absolute twf-top-0 twf-left-0 twf-w-full twf-rounded-t-2xl md:twf-hidden" height="81" viewBox="0 0 343 81" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M343 27.261V0L0 0L0 72.0741C140.201 118.54 188.167 -34.3606 332.828 22.8789C336.323 24.2819 339.713 25.7426 343 27.261Z" fill="#F8F2FF" />
  </svg>
`;
